import React, { useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../contexts/AuthContext";
import { ScreenContext } from "../contexts/ScreenContext";

import List from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/Grid";

import Button from "@material-ui/core/Button";
import UpdateIcon from "@material-ui/icons/Update";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import NoteIcon from "@material-ui/icons/Note";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";

import { purple, pink, yellow, grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  listMenu: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 10,
    paddingBottom: 10,
    overflowX: "auto",
  },
  listItem: {
    paddingRight: 10,
  },
  myNotes: {
    color: theme.palette.getContrastText(yellow[500]),
    backgroundColor: yellow[500],
    "&:hover": {
      backgroundColor: yellow[700],
    },
    borderColor: yellow[900],
  },
  dailyMessage: {
    color: theme.palette.getContrastText(pink[500]),
    backgroundColor: pink[500],
    "&:hover": {
      backgroundColor: pink[700],
    },
    borderColor: pink[700],
    minWidth: "max-content",
  },
  toggl: {
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[500],
    "&:hover": {
      backgroundColor: purple[700],
    },
    borderColor: purple[700],
  },
  zoho: {
    color: theme.palette.getContrastText(grey[700]),
    backgroundColor: grey[500],
    "&:hover": {
      backgroundColor: grey[700],
    },
    borderColor: grey[700],
  },
}));

const DashBoardButtons = React.memo((props) => {
  const classes = useStyles();
  const { isSuperAdmin } = useContext(AuthContext);
  const { isMobile } = useContext(ScreenContext);

  const { toggleNote, toggleDailyMessage } = props;

  return (
    <React.Fragment>
      <List className={classes.listMenu}>
        <ListItem className={classes.listItem}>
          <Button
            variant="contained"
            onClick={toggleNote}
            className={classes.myNotes}
            startIcon={<NoteIcon />}
            disableElevation
          >
            Notes
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href="/manage-hours"
            variant="contained"
            color="primary"
            startIcon={<AccessAlarmIcon />}
            disableElevation
          >
            Hours
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href="https://track.toggl.com/timer"
            target="_blank"
            variant="contained"
            className={classes.toggl}
            startIcon={<UpdateIcon />}
            disableElevation
          >
            Toggl
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href="https://please.fixthis.it/"
            target="_blank"
            variant="contained"
            className={classes.zoho}
            startIcon={<ConfirmationNumberIcon fontSize="small" />}
            disableElevation
          >
            ZOHO
          </Button>
        </ListItem>
        {isSuperAdmin && (
          <ListItem className={classes.listItem}>
            <Button
              variant="contained"
              onClick={toggleDailyMessage}
              className={classes.dailyMessage}
              startIcon={<NotificationsActiveIcon />}
              disableElevation
            >
              D-Message
            </Button>
          </ListItem>
        )}
      </List>
    </React.Fragment>
  );
});

export default DashBoardButtons;
